@if (!customImagesMode) {
  @if (mainImage$ | async; as main) {
    <cx-media [container]="main"></cx-media>
    <u class="enlargeImg pl-1 pt-2 pb-4" (click)="enlargeImg(main?.zoom?.url)">
      Click Image to Enlarge
    </u>
  }

  @if (thumbs$ | async; as thumbs) {
    @if (thumbs.length) {
      <cx-carousel
        class="thumbs"
        [items]="thumbs"
        itemWidth="120px"
        [hideIndicators]="false"
        [template]="thumb"
      ></cx-carousel>
    }
  }

  <ng-template #thumb let-item="item">
    <cx-media
      [container]="item.container"
      tabindex="0"
      (focus)="openImage(item.container)"
      [class.is-active]="isActive(item.container) | async"
    >
    </cx-media>
  </ng-template>
} @else {
  <!-- Custom Main Image -->
  <cx-media [container]="customMain?.product"></cx-media>

  <u class="enlargeImg pl-1 pt-2 pb-4" (click)="enlargeImg(customMain?.zoom?.url)">
    Click Image to Enlarge
  </u>

  <!-- Custom Thumbnails -->
  @if (customThumbs.length) {
    <cx-carousel
      class="thumbs"
      [items]="customThumbs"
      itemWidth="120px"
      [hideIndicators]="false"
      [template]="customThumb"
    >
    </cx-carousel>
  }

  <ng-template #customThumb let-item="item">
    <cx-media [container]="item.thumbnail || item.product"></cx-media>
  </ng-template>
}

<div class="pd-container-info">
  <div class="d-flex col-12 item heading">
    <div class="col-6 font-text-bold font-size-17">Product Details</div>
    <div class="col-6"></div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.hazmat' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.hazmat }}</div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.packageUnit' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.packageUnit }}</div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.packageWeight' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.packageWeight }}</div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.packageQty' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.packageQty }}</div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.moq' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.moq }}</div>
  </div>

  <div class="d-flex col-12 item">
    <div class="col-6">{{ 'productList.label.palletQty' | cxTranslate }}</div>
    <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.palletQty }}</div>
  </div>

  @if (variantProductData?.stockingLocation) {
    <div class="d-flex col-12 item">
      <div class="col-6">{{ 'productList.label.stockingLocation' | cxTranslate }}</div>
      <div class="col-6 font-text-600 font-sm-size">{{ variantProductData?.stockingLocation }}</div>
    </div>
  }
</div>

<ng-container>
  <div class="selected-config-styles">
    <div class="selected-config-heading font-size-17">Selected Configuration</div>

    <div class="d-flex material-no">
      <div class="mr-4 label">Material #:</div>
      <div>{{ variantProductData?.code }}</div>
    </div>

    @if (variantProductData?.hasPricing && (variantProductData?.addToCartEnabled == "" || variantProductData?.addToCartEnabled?.toLowerCase() === "no") ||
        variantProductData?.hasPricing && variantProductData?.addToCartEnabled?.toLowerCase() === "yes" && variantProductData?.rfqEligible?.toLowerCase() === "yes") {
    <div class="d-flex material-no">
      <div class="mr-4 label">{{ 'productList.label.listPrice' | cxTranslate }}:</div>
      <div class="pricing-margin">
        {{
        (((variantProductData?.callForPricing | lowercase) === 'yes') || (variantProductData?.knbrPrice?.listPrice == 0))
        ? variantProductData?.knbrPrice?.listPrice == 0 ? 'Request a Quote' : variantProductData?.pricingText
        : variantProductData?.knbrPrice?.formatedListPrice
        }}
      </div>
    </div>

    <div class="d-flex material-no">
      <div class="mr-4 label">{{ 'productList.label.netPrice' | cxTranslate }}:</div>
      <div class="pricing-margin">
        {{
        (((variantProductData?.callForPricing | lowercase) === 'yes') || (variantProductData?.knbrPrice?.netPrice == 0))
        ? variantProductData?.knbrPrice?.netPrice == 0 ? 'Request a Quote' : variantProductData?.pricingText
        : variantProductData?.knbrPrice?.formatedNetPrice
        }}
      </div>
    </div>
    }
  </div>
</ng-container>
